<template>
  <div class="overlay" :class="show ? 'overlay--active' : ''">
    <span class="overlay__bg" />
    <div class="overlay__content">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      default: false,
      type: Boolean,
    },
  },
}
</script>

<style lang="postcss" scoped>
.overlay {
  @apply fixed inset-0 z-30;
  transition: opacity 0.3s ease;

  & .overlay__bg {
    @apply absolute inset-0 z-0;
  }
  & .overlay__content {
    @apply flex justify-center items-center;
    @apply absolute inset-0 z-1;
  }

  &:not(.overlay--active) {
    @apply opacity-0 pointer-events-none;
  }
}

@screen mobile {
  .overlay .overlay__bg {
    @apply bg-white;
  }
}

@screen desktop {
  .overlay .overlay__bg {
    @apply bg-black-plain;
    opacity: 0.35;
  }
  .overlay .overlay__content {
    @apply pt-page;
  }
}
</style>
